import { Search } from "lucide-react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@needl-ai/common/components/ui/tooltip";

interface SearchChatButtonProps {
  onSearchChat?: () => void;
  isStreaming?: boolean;
  isLoading?: boolean;
  hasIncompleteAttachments?: boolean;
  isCollapsed?: boolean;
}

const SearchChatButton = ({
  onSearchChat,
  isStreaming = false,
  isLoading = false,
  hasIncompleteAttachments = false,
  isCollapsed = false,
}: SearchChatButtonProps) => {
  const isDisabled = isStreaming || isLoading || hasIncompleteAttachments;

  const buttonClass = !isDisabled
    ? `${
        isCollapsed
          ? "w-12 h-12 rounded-lg flex items-center justify-center"
          : "w-full h-12 rounded-lg flex items-center gap-4 px-4"
      } transition-colors font-normal hover:font-medium active:font-medium text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 active:text-gray-900 dark:text-gray-200 dark:hover:bg-neutral-800 dark:hover:text-white dark:active:text-white`
    : `${
        isCollapsed
          ? "w-12 h-12 rounded-lg flex items-center justify-center"
          : "w-full h-12 rounded-lg flex items-center gap-4 px-4"
      } transition-colors font-normal text-sm opacity-75 cursor-not-allowed text-gray-400`;

  const tooltipText =
    isStreaming || isLoading
      ? "Search disabled during processing..."
      : hasIncompleteAttachments
        ? "Complete file uploads before searching"
        : "Search chat history";

  if (isCollapsed) {
    return (
      <div className="px-2">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                onClick={isDisabled ? undefined : onSearchChat}
                className={buttonClass}
                disabled={isDisabled}
                aria-label={tooltipText}
                data-testid="search-chat-button"
              >
                <Search
                  size={16}
                  className="hover:text-gray-900 active:text-gray-900 dark:hover:text-white dark:active:text-white"
                />
              </button>
            </TooltipTrigger>
            <TooltipContent side="right">
              <p>{tooltipText}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    );
  }

  return (
    <div className="px-4">
      <button
        onClick={isDisabled ? undefined : onSearchChat}
        className={buttonClass}
        disabled={isDisabled}
        title={tooltipText}
        data-testid="search-chat-button"
      >
        <Search
          size={16}
          className="hover:text-gray-900 active:text-gray-900 dark:hover:text-white dark:active:text-white"
        />
        {!isCollapsed && "Search Chat"}
      </button>
    </div>
  );
};

export default SearchChatButton;
